import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  DocType,
  RetrievedDocumentReferenceLink,
  UpdateDocumentMetadataResponse,
} from '../../../../components/v2/components/imageHandling/types/types';
import { AppDispatch } from '@store/types';
import { refreshForceRetrieveFromSource } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { Alert } from '@helpers';
import { backendCall, createApiCall } from '@reducers/utils';
import { pushMessage } from '@reducers/v2/messagesBus/messagesBus.slice';
import { ImageDocumentMessageType } from '@reducers/v2/messagesBus/types';

export const updateImageMetadata = createAsyncThunk<
  UpdateDocumentMetadataResponse,
  {
    data: { documentId: number; documentTags?: DocType[] | null; documentLinks?: Partial<RetrievedDocumentReferenceLink>[] };
    onSuccess?: () => void;
  },
  { dispatch: AppDispatch }
>('imageHandlingV2/updateImageMetadata', async ({ data, onSuccess }, { dispatch }) => {
  refreshForceRetrieveFromSource();

  return new Promise((resolve, reject) => {
    dispatch(
      backendCall(
        createApiCall((api) => api.imageHandling.updateImageMetadata, {
          params: data,
          onSuccess: (r: UpdateDocumentMetadataResponse) => {
            dispatch(
              pushMessage({
                key: data.documentId,
                message: {
                  messageType: ImageDocumentMessageType.IMAGE_METADATA_UPDATED,
                  payload: data,
                },
              })
            );
            onSuccess?.();
            resolve(r);
          },
          onError: () => {
            // TODO: handle error, revert changes
            Alert({ title: 'Error update image metadata. Please, try again.' });
            reject(new Error('Failed to update image metadata'));
          },
        })
      )
    );
  });
});
